import { NgModule, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TailwindThemeService } from '@backoffice-frontend/shared/ui-tailwind';
import { SideNavService } from '@clean-code/shared/templates/ui-tailwind-full-width';
import * as Sentry from '@sentry/angular-ivy';
import tailwindThemeConfig from '../assets/config/tailwind-theme.config.json';
import { environment } from '../environments/environment';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { navigationItems } from './pages/navigaton';

@NgModule({
  imports: [
    MatDialogModule,
    // OAuthModule.forRoot(environment.auth as OAuthModuleConfig),
    // OAuthAuthModule.forRoot(environment.auth as OAuthModuleConfig),
    DashboardModule,
  ],
  providers: [
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializerFactory,
    //   deps: [AuthConfigService],
    //   multi: true,
    // },
    // {
    //   provide: MatPaginatorIntl,
    //   useClass: MatPaginationIntlService,
    // },
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandlerService,
    // },
    // provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(sideNavService: SideNavService) {
    if (environment.enableSentry) {
      inject(Sentry.TraceService);
    }

    sideNavService.addNavigation(navigationItems);

    const tailwindService = inject(TailwindThemeService);

    tailwindService.loadConfig(tailwindThemeConfig);
  }
}
